import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dec_admin_token");
  if (token && (config.url?.startsWith("/admin") || config.url?.startsWith("/auth/"))) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!err?.response) return "We couldn't reach the server. Please check your connection and try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : "";
        return field ? `${field}: ${e.msg}` : e?.msg;
      })
      .filter(Boolean)
      .join(". ");
  }
  return "Something went wrong. Please try again.";
}

export function formatSlot(date, time) {
  const d = new Date(`${date}T${time}:00`);
  return d.toLocaleString("en-US", { weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export function formatTime(time) {
  const [h, m] = time.split(":").map(Number);
  const d = new Date(2000, 0, 1, h, m);
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}
